const PropTypes = require('prop-types');
const React = require('react');
const moment = require('moment');
const formatAmount = require('../shared/format_amount.js');

class PriceGuideTransaction extends React.Component {
  static propTypes = {
    transaction: PropTypes.object.isRequired,
  };

  render() {
    return (
      <tr className="transaction">
        <td>{moment(this.props.transaction.date).format('MM/DD/YYYY')}</td>
        <td>{this.props.transaction.condition}</td>
        <td><span className="price-history-table-price">{formatAmount(this.props.transaction.price_final)}</span></td>
      </tr>
    );
  }
}

module.exports = PriceGuideTransaction;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/price_guide_transaction.jsx